var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-shell auth-shell--centered" }, [
    _c("div", { staticClass: "auth-card" }, [
      _vm._m(0),
      _c("div", { staticClass: "auth-card__heading" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("pages.login.description")))]),
        _c("h5", [
          _vm._v(
            _vm._s(_vm.$t("pages.appConfiguration.appConfigurationCompanyCode"))
          ),
        ]),
      ]),
      _c(
        "form",
        {
          staticClass: "auth-card__panel",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.getAppConfiguration.apply(null, arguments)
            },
          },
        },
        [
          _vm.error
            ? _c(
                "div",
                { staticClass: "alert alert-danger", attrs: { role: "alert" } },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm._e(),
          _c("code-company-field", {
            attrs: { form: _vm.form, name: "codeCompany", id: "codeCompany" },
          }),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("vue-button", {
                staticClass: "btn btn-primary btn-block p-3 text-uppercase",
                attrs: {
                  title: _vm.$t(
                    "pages.appConfiguration.appConfigurationCheckCode"
                  ),
                  loading: _vm.isLoading,
                  type: "submit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "auth-card__copyright" }, [
        _vm._v(" " + _vm._s(_vm.copyright) + " "),
      ]),
      _c(
        "div",
        { staticClass: "auth-card__stores" },
        [
          _c("google-play-badge", { staticClass: "mr-3" }),
          _c("apple-store-badge"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-card__logo" }, [
      _c("img", {
        attrs: { src: require("@/assets/logos/sucasuc/logo.png"), alt: "logo" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }